import actions from './actions';
import actionTypes from './constants/action-types';
import constants from './constants';
import reducers from './reducers';
import selectors from './selectors';
import injections from './injections';

export default {
  actions,
  actionTypes,
  constants,
  reducers,
  selectors,
  injections,
};
